import React, { Suspense } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import { PropTypes } from "prop-types";
import { useNavigate } from "react-router-dom";
import reactWrapper from "@harbor/elements/utils/react/wrapper";
import _ from "lodash";

//reducers
import * as actions from "../actions";

//style
import css from "../overviewMagneticStyle.less";

//components
import AppHOC from "../../../generics/AppHOC";
import DashletTable from "../../../common/DashletTable";
import HarborDonut from "../../../common/HbrDonut";
import Spinner from "../../../common/Spinner";
import QoeListComponent from "../../../common/QoeListComponent";

//utils
import { getDonutData } from "../../../utils/views/overview";
import {
  hasFilterChanged,
  getCustomListApi,
  exportCsvZip,
} from "../../../utils/common";
import qoeTableConfig from "./config/table/appQoeTableConfig";
import qoeDonutConfig from "./config/donut/appQoeDonutConfig";
import { parseApplSummary } from "../../../config/apiParsers/overview";
import { columnsName, getSource } from "./config/table/harborTableHeaderConfig";
import { COLOR, routeURLs } from "../../../utils/enums";
import { tViews } from "../../../utils/table";
import { timeFilterTypesCustomV4 } from "../../../utils/enums";
import {
  shortDisplayDate24HourWithSec,
  formatDate,
  displayDateTime,
} from "../../../utils/displayTime";
import { formatNumber } from "../../../utils/format";

const ErrorComponent = React.lazy(
  () => import("../../../common/ErrorComponent"),
);

const mapStateToProps = (state) => {
  return {
    overview: state.vanalytics.overview,
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

const [HbrSelect, HbrCard, HbrOption, HbrButton, HbrIconButton, HbrTooltip] =
  reactWrapper([
    "hbr-select",
    "hbr-card",
    "hbr-option",
    "hbr-button",
    "hbr-icon-button",
    "hbr-tooltip",
  ]);
const allQoEFilter = ["good", "fair", "poor"];

const ApplicationDetailsButton = ({ label, ariaLabel }) => {
  const navigate = useNavigate();

  return (
    <HbrButton
      variant="text"
      onClick={() => navigate(routeURLs.applications)}
      aria={{ label: ariaLabel }}
    >
      {label}
    </HbrButton>
  );
};

ApplicationDetailsButton.propTypes = {
  label: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string.isRequired,
};

export class DashletAppView extends React.Component {
  constructor() {
    super();

    this.state = {
      appDonutData: null,
      appDonutLoader: true,
      appDonutError: false,
      appStackedData: null,
      appStackedLoader: true,
      appStackedError: false,
      appStackedDataDes: null,
      appStackedLoaderDes: true,
      appStackedErrorDes: false,
      appdataProcessed: false,
    };
    this.title = (
      <div data-cy="application-link">
        <div className="hbr-type-h2">{tViews("appViewApplication")}</div>
      </div>
    );

    this.qoeFilters = ["good", "fair", "poor", "unknown"];
    this.dropdown = {
      options: [
        { label: tViews("appViewByQoE"), value: "qoe" },
        {
          label: tViews("appViewByGoodQoE"),
          value: this.qoeFilters[0],
        },
        {
          label: tViews("appViewByFairQoE"),
          value: this.qoeFilters[1],
        },
        { label: tViews("appViewByPoorQoE"), value: this.qoeFilters[2] },
      ],
    };
    this.filters = {
      viewFilter: {
        label: tViews("appViewBy"),
        value: "view",
        action: this.onViewChange.bind(this),
        items: {
          qoe: {
            label: tViews("appViewByQoE"),
            value: "qoe",
            config: {
              donut: qoeDonutConfig,
              table: qoeTableConfig,
            },
          },
          good: {
            label: tViews("appViewByGoodQoE"),
            value: "good",
            config: {
              donut: qoeDonutConfig,
              table: qoeTableConfig,
            },
          },
          fair: {
            label: tViews("appViewByFairQoE"),
            value: "fair",
            config: {
              donut: qoeDonutConfig,
              table: qoeTableConfig,
            },
          },
          poor: {
            label: tViews("appViewByPoorQoE"),
            value: "poor",
            config: {
              donut: qoeDonutConfig,
              table: qoeTableConfig,
            },
          },
        },
      },
    };
    this.donutConfig = false;
    this.tableConfig = false;
  }

  getData = (props, globalV4PayloadReport, isReporting) => {
    this.props.setAppsWithFamilySLA(undefined);
    getCustomListApi(props, globalV4PayloadReport, isReporting);
  };

  componentDidMount() {
    this.setState({
      appDonutData: null,
      appDonutLoader: true,
      appStackedData: null,
      appStackedLoader: true,
      appdataProcessed: false,
    });
    this.updateDashletFilter({ type: "all", view: "qoe" });

    if (
      this.props.isReporting &&
      this.props.executiveSummary.reportData &&
      this.props.executiveSummary.reportData.length > 0
    ) {
      const { current_period_start, current_period_end, time_range } =
        this.props.executiveSummary.reportData[0];

      let globalV4PayloadReport = {
        time_frame: timeFilterTypesCustomV4[time_range],
        entry_ts: {
          start: shortDisplayDate24HourWithSec(
            formatDate(current_period_start).utc(),
          ),
          end: shortDisplayDate24HourWithSec(
            formatDate(current_period_end).utc(),
          ),
        },
      };
      this.getData(this.props, globalV4PayloadReport, this.props.isReporting);
      return;
    }
  }

  componentDidUpdate(prevProps) {
    if (hasFilterChanged(this.props.globalFilter, prevProps.globalFilter)) {
      const { app } = this.props.overview.dashletFilter;
      const { setDashletFilter, setDashletLoading } = this.props.actions;
      setDashletLoading("APP");
      setDashletFilter(
        "APP",
        Object.assign({}, app, { type: "all", view: "qoe" }),
      );
      this.setState({
        appdataProcessed: false,
      });
    }
    if (
      !_.isEqual(
        this.props.globalFilter.app_data_with_family_sla,
        prevProps.globalFilter.app_data_with_family_sla,
      )
    ) {
      if (
        this.props &&
        this.props.globalFilter.app_data_with_family_sla != undefined &&
        this.props.globalFilter.app_data_with_family_sla &&
        this.props.globalFilter.app_data_with_family_sla.length > 0 &&
        !this.state.appdataProcessed
      ) {
        this.setState({
          appDonutData: null,
          appDonutLoader: true,
          appStackedData: null,
          appStackedLoader: true,
          appdataProcessed: false,
        });
        this.updateView();
      } else if (
        this.props &&
        this.props.globalFilter.app_data_with_family_sla != undefined &&
        this.props.globalFilter.app_data_with_family_sla &&
        this.props.globalFilter.app_data_with_family_sla.length == 0 &&
        !this.state.appdataProcessed
      ) {
        let vqoe_donut = { good: 0, poor: 0, fair: 0, unknown: 0 };
        let vqoe_donut_summary = { summary: {} };
        vqoe_donut_summary["summary"] = vqoe_donut;
        let vqoe_stacked_summary = { detail: [] };
        this.setState({
          appDonutData: vqoe_donut_summary,
          appDonutLoader: false,
          appStackedData: parseApplSummary(vqoe_stacked_summary),
          appStackedLoader: false,
          appdataProcessed: true,
        });
        if (this.props?.isReporting) {
          this.props.isReportAppCallback(true);
        }
      } else if (
        this.props.globalFilter.app_data_with_family_sla == undefined
      ) {
        this.setState({
          appDonutData: null,
          appDonutLoader: true,
          appStackedData: null,
          appStackedLoader: true,
          appdataProcessed: false,
        });
      }
    } else if (
      !this.state.appdataProcessed &&
      this?.props?.globalFilter?.app_data_with_family_sla?.length == 0
    ) {
      let vqoe_donut = { good: 0, poor: 0, fair: 0, unknown: 0 };
      let vqoe_donut_summary = { summary: {} };
      vqoe_donut_summary["summary"] = vqoe_donut;
      let vqoe_stacked_summary = { detail: [] };
      this.setState({
        appDonutData: vqoe_donut_summary,
        appDonutLoader: false,
        appStackedData: parseApplSummary(vqoe_stacked_summary),
        appStackedLoader: false,
        appdataProcessed: true,
      });
      if (this.props?.isReporting) {
        this.props.isReportAppCallback(true);
      }
    }
  }

  onViewChange(view) {
    this.updateDashletFilter({ view });
  }

  updateDashletFilter(filter) {
    const { app } = this.props.overview.dashletFilter;
    const { setDashletFilter, setDashletLoading } = this.props.actions;
    const updatedAppFilter = Object.assign({}, app, filter);
    setDashletLoading("APP");
    setDashletFilter("APP", updatedAppFilter);
    this.setState({
      appDonutData: null,
      appDonutLoader: true,
      appStackedData: null,
      appStackedLoader: true,
      appdataProcessed: false,
    });
    this.updateView(updatedAppFilter);
  }

  updateView(app = this.props.overview.dashletFilter.app) {
    const config = this.filters.viewFilter.items[app.view].config;
    this.donutConfig = config.donut;
    if (this.props.isReporting) {
      config.table.columns[1].tooltip = false;
    }
    this.tableConfig = config.table;
    this.topTableConfig = {
      ...qoeTableConfig,
      title: tViews("tableHeadingBottom"),
    };
    const updateSite =
      this.props.globalFilter.selectedSite > 0
        ? {
            site_id: this.props.globalFilter.selectedSite,
          }
        : {};
    this.tableConfig.columns[3].title =
      Object.entries(updateSite).length > 0
        ? tViews("circuitQoeDistribution")
        : tViews("appQoeDistribution");

    this.tableConfig.columns[2].title =
      Object.entries(updateSite).length > 0
        ? tViews("circuitQoeSiteCount")
        : tViews("appQoeSiteCount");
    if (
      this.props &&
      this.props.globalFilter.app_data_with_family_sla != undefined &&
      this.props.globalFilter.app_data_with_family_sla &&
      this.props.globalFilter.app_data_with_family_sla.length > 0
    ) {
      const resData = this.props.globalFilter.app_data_with_family_sla;
      // get donut chart data
      const qoeData = { good: 0, poor: 0, fair: 0, unknown: 0 };
      for (const { vqoe_status } of resData) qoeData[vqoe_status] += 1;
      qoeData.bad = qoeData.poor;
      delete qoeData.poor;
      // get table data
      const qoeFilter = app.view === "qoe" ? allQoEFilter : [app.view];
      const tableData = resData
        .filter((item) => qoeFilter.includes(item.vqoe_status))
        .sort((item1, item2) => item2.usage - item1.usage)
        .slice(0, 50)
        .sort((item1, item2) => item1.vqoe_score - item2.vqoe_score);

      this.setState({
        appDonutData: { summary: qoeData },
        appDonutLoader: false,
        appStackedData: parseApplSummary({ detail: tableData.slice(0, 5) }),
        appStackedLoader: false,
        appdataProcessed: true,
      });
      if (this.props.isReporting) {
        this.setState({
          appStackedDataDes: parseApplSummary({ detail: tableData.slice(-5) }),
          appStackedLoaderDes: false,
        });
        // callback function for executive summary report to identify data is present for app view
        this.props.isReportAppCallback(true);
      }
    }
  }
  renderFilters() {
    const options = this.dropdown.options;
    const { app } = this.props.overview.dashletFilter;
    return (
      <HbrSelect
        key={options[0].label}
        style={{ width: "110px" }}
        value={app.view}
        onHbr-change={(event) => {
          this.onViewChange(event.currentTarget.value);
        }}
      >
        {options.map((option) => (
          <HbrOption key={option.label} value={option.value}>
            {option.label}
          </HbrOption>
        ))}
      </HbrSelect>
    );
  }

  handleZipCSVExport = () => {
    const donutData = this.state.appDonutData?.summary || {};
    const tableData = this.state.appStackedData?.detail || [];

    const donutLabels = this.donutConfig?.text || qoeDonutConfig.text;
    const tableColumns = this.tableConfig?.columns || qoeTableConfig.columns;
    const fileDateTime = displayDateTime(new Date(), "yyyy-MM-dd hh mm ss aa");
    const selectedView = this.props.overview?.dashletFilter?.app?.view;
    const selectedDropdownOption = this.dropdown.options.find(
      (option) => option.value === selectedView,
    );

    const selectedDropdownLabel =
      selectedDropdownOption?.label || selectedView || "QoE";
    const selectedDropdownFileName = selectedDropdownLabel.replace(/\W+/g, "_");

    const tableHeaders = [
      tableColumns[0].title,
      tableColumns[1].title,
      `${tableColumns[1].title} ${tViews("trendingAppsChange")}`,
      tableColumns[2].title,
      `${tableColumns[3].title} - ${donutLabels.bad.tooltip}`,
      `${tableColumns[3].title} - ${donutLabels.fair.tooltip}`,
      `${tableColumns[3].title} - ${donutLabels.good.tooltip}`,
      `${tableColumns[3].title} - ${donutLabels.unknown.tooltip}`,
    ];

    exportCsvZip({
      zipName: `${tViews("app360Overview")}_${tViews("allSitesView.application")}_${selectedDropdownFileName}_${fileDateTime}.zip`,
      files: [
        {
          name: `${tViews("allSitesView.application")}_${tViews("a11yLabels.donut")}_${tViews("app360.afQoe")}_${tViews("a11yLabels.data")}_${fileDateTime}.csv`,
          headers: [
            tableColumns[1].title,
            tViews("predictiveNetworks.applicationCount"),
          ],
          rows: [
            [donutLabels.good.tooltip, donutData.good || 0],
            [donutLabels.fair.tooltip, donutData.fair || 0],
            [
              donutLabels.bad.tooltip,
              donutData.bad || donutData.poor || donutData.poor || 0,
            ],
            [donutLabels.unknown.tooltip, donutData.unknown || 0],
          ],
        },
        {
          name: `${tViews("tableHeadingTopApp")}_${tViews("optimization.csvLabels.tableCsvTitle")}_${fileDateTime}.csv`,
          headers: tableHeaders,
          rows: tableData.length
            ? tableData.map((row) => {
                const qoeScore = formatNumber(row.vqoe_score);
                const qoeChange = formatNumber(row.vqoe_change);

                return [
                  row.application,
                  qoeScore,
                  qoeChange,
                  row.distributionTotal,
                  row.distribution?.poor || 0,
                  row.distribution?.fair || 0,
                  row.distribution?.good || 0,
                  row.distribution?.gray || 0,
                ];
              })
            : [Array(tableHeaders.length).fill(tViews("noDataAvailable"))],
        },
      ],
    });
  };

  render() {
    const errorAppDonut =
      this.props.globalFilter &&
      this.props.globalFilter.applicationAggregateData &&
      this.props.globalFilter.applicationAggregateData.resObj &&
      this.props.globalFilter.applicationAggregateData.resObj.message !=
        "successful";

    const errorApp =
      this.props.globalFilter &&
      this.props.globalFilter.applicationAggregateData &&
      this.props.globalFilter.applicationAggregateData.resObj &&
      this.props.globalFilter.applicationAggregateData.resObj.message !=
        "successful";
    let loader =
      this.props.globalFilter.app_data_with_family_sla == undefined
        ? true
        : false;
    const { timePeriodSelected } = this.props.globalFilter;
    const showCsvExport =
      this.state.appStackedData?.detail?.length > 0 ||
      Object.values(this.state.appDonutData?.summary || {}).some(Boolean);
    return (
      <HbrCard
        className={
          this.props.isReporting
            ? css["app-dashlet-reporting"]
            : css["app-dashlet-card"]
        }
        data-cy="app-dashlet-card"
        container={true}
        data-testid="application-dashlet"
      >
        <div className="app-dashlet-view" data-cy="app-dashlet-view">
          {!this.props.isReporting && (
            <div className="longer-title-block">
              <div className="title-block">
                <div className="header-content" role="heading" aria-level={"2"}>
                  {this.title}
                </div>
                <div className="filters">{this.renderFilters()}</div>
              </div>
              <div className="app-view-actions">
                <ApplicationDetailsButton
                  label={tViews("appViewByViewDetails")}
                  ariaLabel={tViews("a11yLabels.overviewApplicationDetails")}
                />
                {showCsvExport && (
                  <HbrTooltip
                    content={tViews("a11yLabels.zipDownloadTooltipText")}
                    hoist
                  >
                    <span>
                      <HbrIconButton
                        size="20px"
                        name="file-csv"
                        onClick={this.handleZipCSVExport}
                        arialabel={tViews("a11yLabels.csvZipDownloadLabel")}
                        data-testid="overview-applications-csv-btn"
                      />
                    </span>
                  </HbrTooltip>
                )}
              </div>
            </div>
          )}

          {this.state &&
          (loader ||
            this.state.appStackedLoader ||
            this.state.appDonutLoader) ? (
            <div
              className="spinner-component-app-view"
              data-cy="spinner-component-app-view"
            >
              <Spinner />
            </div>
          ) : errorAppDonut || errorApp ? (
            <Suspense fallback={<Spinner />}>
              <ErrorComponent
                {...errorApp}
                {...errorAppDonut}
                width={"210px"}
                errorCode={
                  this.props.globalFilter.applicationAggregateData.resObj
                    .errorCode
                }
                message={
                  this.props.globalFilter.applicationAggregateData.resObj
                    .message
                }
                className={"small-dashlet-error"}
              />
            </Suspense>
          ) : (
            <div
              className={
                this.props.isReporting
                  ? "content-block-reporting"
                  : "content-block-app"
              }
            >
              {this.state &&
              ((this.state.appDonutLoader && this.state.appDonutData == null) ||
                loader) ? (
                <Spinner />
              ) : (
                this.state &&
                this.state.appDonutData &&
                !this.state.appDonutLoader &&
                !loader &&
                this.donutConfig &&
                this.state.appDonutData.summary && (
                  <div
                    className={
                      this.props.isReporting
                        ? "donut-container-reporting"
                        : "donut-container"
                    }
                  >
                    {this.props.isReporting && (
                      <div className="title-block hbr-type-h3">
                        {tViews("applicationQoeBreakdown")}
                      </div>
                    )}
                    <div className="donut-section">
                      <div className="app-donut-overlay-container">
                        <HarborDonut
                          data={getDonutData(
                            this.donutConfig.text,
                            this.state.appDonutData.summary,
                          )}
                          donutLabel={""}
                        />
                        <span className="app-donut-center-label">
                          {tViews("appsLabel")}
                        </span>
                      </div>
                      <div className="legend-app-view">
                        <QoeListComponent
                          overviewPage={true}
                          iconType={[
                            COLOR.GOOD,
                            COLOR.FAIR,
                            COLOR.POOR,
                            COLOR.GRAY,
                          ]}
                          qoeScore={[0, 0, 0, 0]}
                          qoeLabels={[
                            qoeDonutConfig.text.good.title,
                            qoeDonutConfig.text.fair.title,
                            qoeDonutConfig.text.bad.title,
                            qoeDonutConfig.text.unknown.title,
                          ]}
                          ellipsis={true}
                        />
                      </div>
                    </div>
                  </div>
                )
              )}
              {(this.state &&
                this.state.appStackedLoader &&
                this.state.appStackedData == null) ||
              loader ? (
                <Spinner />
              ) : (
                this.state &&
                this.state.appStackedData &&
                this.tableConfig &&
                !this.state.appStackedLoader &&
                !loader &&
                this.state.appStackedData.detail && (
                  <div
                    className={
                      this.props.isReporting
                        ? "table-chartview-container"
                        : "table-view-app"
                    }
                  >
                    <div
                      className={
                        this.props.isReporting
                          ? "table-chartview-reporting"
                          : "table-chartview"
                      }
                    >
                      {this.props.isReporting &&
                        this.state &&
                        this.state.appStackedDataDes &&
                        this.state.appStackedDataDes.detail && (
                          <>
                            <div className="title-app-dashlet hbr-type-h3">
                              {tViews("tableHeadingBottom")}
                            </div>
                            <DashletTable
                              config={this.topTableConfig}
                              data={this.state.appStackedDataDes.detail}
                              timeFilterType={timePeriodSelected}
                              chartTooltip={
                                this.props.isReporting ? false : true
                              }
                              widget={"app"}
                            ></DashletTable>
                          </>
                        )}
                    </div>
                    <div
                      className={
                        this.props.isReporting
                          ? "table-chartview-reporting"
                          : "table-chartview"
                      }
                    >
                      <div className="title-app-dashlet-left hbr-type-h3">
                        {tViews("tableHeadingTopApp")}
                      </div>
                      <DashletTable
                        config={this.tableConfig}
                        data={this.state.appStackedData.detail}
                        timeFilterType={timePeriodSelected}
                        chartTooltip={this.props.isReporting ? false : true}
                        widget={"app"}
                        source={getSource([])}
                        columnsName={columnsName()}
                        style={{ height: "40px", width: "410px" }}
                      ></DashletTable>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </HbrCard>
    );
  }
}

DashletAppView.propTypes = {
  overview: PropTypes.object.isRequired,
  globalFilter: PropTypes.object.isRequired,
  actions: PropTypes.object,
  setAggregateAppData: PropTypes.func.isRequired,
  isReportAppCallback: PropTypes.func,
  setAppFamilySLA: PropTypes.func.isRequired,
  setAppsWithFamilySLA: PropTypes.func.isRequired,
  isReporting: PropTypes.bool,
  timeRange: PropTypes.any,
  executiveSummary: PropTypes.object.isRequired,
};

DashletAppView.defaultProps = {
  isReporting: false,
  executiveSummary: {},
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppHOC(DashletAppView));
